import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import EditPackageDrawer from "./EditPackageDrawer";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import edit from "../assets/svg/edit.svg";
import slip from "../assets/svg/slip.svg";
import arrow from "../assets/svg/arrow-down-circle.svg";
import AccordionViaTableRowName from "./AccordionViaTableRowName";
import PackageStatus from "./PackageStatus";
import SerialNumber from "./SerialNumber";
import PackageDetails from "./PackageDetails";
import CustomTable from "./CustomTable";
import { addMilliseconds, format, fromUnixTime } from "date-fns";
import { arrayRemove, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import SelectionTag from "./SelectionTag";
import SimpleBar from "simplebar-react";
import { toast } from "react-toastify";
import { calculateTotalValues } from "../pages/Shipment/shippingRequest/helper";
import Slip from "../pages/Shipment/Packages/Slip";
import {
  availableSerialNumber,
  updatePackageColidationStatus,
  updateSerialNumber,
} from "./helper";
import { getShipmentDetails } from "../pages/Shipping/Integration/APIService";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllItems,
  getDetailsById,
  getShelfShoppingPackages,
  getUserDetailsById,
  sendNotification,
  sendNotificationFunction,
  updateShelfShoppingPackageDetails,
} from "../helper/functions";
import {
  setPackages,
  setSelectedPackage,
  setSelectedRequest,
} from "../store/commonSlice";
import EditConsolidatedPackageDrawer from "./EditConsolidatedPackageDrawer";

function PackageTraking({
  packageClickHandler,
  selectedPackages,
  collection,
  shipmentCollection,
  steps = [],
  activeStep,
  pageName,
  userClickHandler,
  reloadDetails,
}) {
  const dispatch = useDispatch();
  const {
    selectedRequest: userActiveData,
    selectedPackage: packageActiveData,
  } = useSelector((state) => state.common);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [consolidatePackageDrawerOpen, setConsolidatePackageDrawerOpen] =
    useState(false);
  const [activeDataName, setActiveDataName] = useState(null);
  const [activeDataImage, setActiveDataImage] = useState("");
  const [drawerForAddons, setDrawerOpenForAddOns] = useState(false);
  const [drawerForCustomIQ, setDrawerOpenForCustomIQ] = useState(false);
  const [labelForAddOnDrawer, setLabelForAddOnDrawer] = useState("");
  const [labelForCustomIQDrawer, setLabelForCustomIQDrawer] = useState("");
  const [packageItems, setPackageItems] = useState([]);
  const [editPackageData, setEditPackageData] = useState({});
  const [barcodeValue, setBarcodeValue] = useState("");
  const [slipValue, setSlipValue] = useState("");
  const [dateForSlip, setDateForSlip] = useState();
  const [consolidatePackageData, setConsolidatePackageData] = useState({});
  const slipRef = useRef();
  console.log(packageItems, "packageItemspackageItems");
  console.log(
    shipmentCollection,
    // selectedPackages,
    "shipmentCollection",
  );
  console.log("packageActiveData : ", packageActiveData, selectedPackages);
  console.log(userActiveData, "userActiveData");
  // console.log("pageName", pageName);

  const generateRandomBarcodeValue = () => {
    return Math.floor(100000000 + Math.random() * 900000000).toString();
  };

  const generateSlipNumber = () => {
    const randomNumber = Math.floor(100000 + Math.random() * 900000);
    return randomNumber;
  };

  const getConsolidatePackageData = () => {
    try {
      getDoc(doc(db, "shelfConsolidatedPackages", userActiveData.id)).then(
        async (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data();
            setConsolidatePackageData({ ...data, id: userActiveData.id });
          }
        },
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setBarcodeValue(generateRandomBarcodeValue());
    setSlipValue(generateSlipNumber());
  }, []);

  useEffect(() => {
    if (
      packageActiveData?.arrivedAt !== null &&
      packageActiveData?.arrivedAt?.seconds
    ) {
      let date;
      if (packageActiveData?.arrivedAt?.seconds) {
        date = fromUnixTime(packageActiveData?.arrivedAt?.seconds);
      }

      setDateForSlip(format(new Date(date), "MM.dd.yyyy"));
    }
  }, [packageActiveData?.arrivedAt]);

  useEffect(() => {
    setActiveDataName(null);
    const fetchItemData = async () => {
      if (
        (packageActiveData && Object.keys(packageActiveData).length === 0) ||
        (packageActiveData?.packageItemIds &&
          packageActiveData?.packageItemIds?.length === 0)
      )
        return;
      const itemIdArray =
        collection === "shelfShoppingPackages"
          ? packageActiveData?.shoppingItemIds
          : packageActiveData?.packageItemIds;
      console.log(itemIdArray, "itemIdArray");
      const itemPromises =
        itemIdArray?.length > 0 &&
        itemIdArray?.map(async (itemId) => {
          if (!itemId) return null;
          const itemDocRef = doc(db, "items", itemId);
          const itemDocSnap = await getDoc(itemDocRef);

          if (itemDocSnap.exists()) {
            return itemDocSnap.data();
          }
        });

      const arr = itemPromises && (await Promise.all(itemPromises));
      // console.log(arr, "arr");
      setPackageItems(arr || []);
    };

    fetchItemData();
  }, [packageActiveData, packageActiveData?.packageItemIds]);

  const headCells = [
    { id: "no", label: "No" },
    { id: "name", label: "Item Name" },
    {
      id: "qty",
      label: "Qty",
      align: "right",
    },
    {
      id: "addons",
      label: "Add-ons",
      align: "right",
    },
    {
      id: "customsIQ",
      label: "CustomsIQ",
      align: "right",
    },
    {
      id: "documents",
      label: "Documents",
      align: "right",
    },
  ];

  function createData(
    no,
    item_img,
    itemId,
    name,
    fullName,
    subCategory,
    category,
    qty,
    addons,
    customsIQ,
    receipt_img,
    acceptedAddons,
    path,
  ) {
    return {
      no,
      item_img,
      itemId,
      name,
      fullName,
      subCategory,
      category,
      qty,
      addons,
      customsIQ,
      receipt_img,
      acceptedAddons,
      path,
    };
  }

  const rows =
    packageItems.length > 0 &&
    packageItems?.map((item, index) => {
      return createData(
        index + 1,
        item?.itemImageURL,
        item?.id,
        item?.shortenedName,
        item?.name,
        item?.subcategory,
        item?.category,
        item?.quantity,
        item?.addonsList,
        item?.customiqRestrictions,
        item?.receiptImageURL,
        item?.acceptedAddons,
        arrow,
      );
    });
  const toggleDrawer = (packageActiveData) => {
    if (drawerOpen) {
      // Clear the drawer data when closing
      setEditPackageData({});
    } else {
      setEditPackageData(packageActiveData);
    }
    setDrawerOpen(!drawerOpen);
  };
  const toggleConsolidateDrawer = (packageActiveData) => {
    if (drawerOpen) {
      // Clear the drawer data when closing
      setEditPackageData({});
    } else {
      setEditPackageData(packageActiveData);
    }
    setConsolidatePackageDrawerOpen(!consolidatePackageDrawerOpen);
  };

  const handleBackButton = () => {
    setActiveDataName(null);
  };

  const handlePreparedShipment = async (packageId) => {
    console.log(packageId, "packageId");

    if (pageName === "consolidateRequest") {
      console.log(userActiveData, "userActiveDataadsssdfsaf");
      if (userActiveData?.status !== "CONSOLIDATION_REQUESTED") {
        const docRef = doc(db, "shelfConsolidatedPackages", userActiveData?.id);
        updateDoc(docRef, {
          status:
            userActiveData?.status ===
            "CONSOLIDATION_PREPARE_SHIPMENT_REQUESTED"
              ? "CONSOLIDATION_PREPARE_SHIPMENT_REQUEST_APPROVED"
              : "CONSOLIDATION_RE_PREPARE_PACKAGE_COMPLETED",
        })
          .then(async () => {
            dispatch(
              setSelectedRequest({
                ...userActiveData,
                status:
                  userActiveData?.status ===
                  "CONSOLIDATION_PREPARE_SHIPMENT_REQUESTED"
                    ? "CONSOLIDATION_PREPARE_SHIPMENT_REQUEST_APPROVED"
                    : "CONSOLIDATION_RE_PREPARE_PACKAGE_COMPLETED",
              }),
            );
            const updatedPackageDetails = await getDetailsById(
              [
                {
                  key: "__name__",
                  operator: "==",
                  value: packageActiveData?.id,
                },
              ],
              "shelfConsolidatedPackages",
            );
            await updatePackageColidationStatus(
              updatedPackageDetails[0]?.packageIds,
              {
                packageStatus:
                  userActiveData?.status ===
                  "CONSOLIDATION_PREPARE_SHIPMENT_REQUEST_APPROVED"
                    ? "PREPARE_SHIPMENT_REQUEST_APPROVED"
                    : "RE_PREPARE_PACKAGE_COMPLETED",
                isConsolidatedPackage: true,
              },
            );
            dispatch(setSelectedRequest(updatedPackageDetails[0]));
            toast.success("Status Updated Successfully !");
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        let newData = {},
          packageGlobal = {};

        if (!userActiveData?.serialNumber) {
          getDoc(doc(db, "masterData", "packageSetting")).then(
            async (docSnap) => {
              if (docSnap.exists()) {
                const docData = docSnap.data();
                packageGlobal = docData;
                const serialNo = availableSerialNumber(docData);
                newData["serialNumber"] = serialNo;
              }
            },
          );
        }

        const docRef = doc(db, "shelfConsolidatedPackages", userActiveData?.id);
        const removePackageIds = userActiveData.removePackageIds || [];
        // console.log(removePackageIds, "removePackageIds");

        try {
          const docData = userActiveData;
          removePackageIds?.map(async (id) => {
            const docRef = doc(db, "shelfPackages", id);
            await updateDoc(docRef, {
              isPackageConsolidated: false,
            });
          });
          // Remove packageIds and removePackageIds
          const updatedPackageIds = docData.packageIds.filter(
            (id) => !removePackageIds.includes(id),
          );

          const updatedConsolidation =
            await calculateTotalValues(updatedPackageIds);

          // Update the document with the new arrays
          updateDoc(docRef, {
            ...newData,
            status: "CONSOLIDATION_APPROVED",
            preparedShipmentDate: new Date(),
            packageIds: updatedPackageIds,
            removePackageIds: [],
            packageItemIds: updatedConsolidation?.packageItemIds,
            totalAmount: updatedConsolidation?.totalAmount,
            totalWeight: updatedConsolidation?.totalWeight,
            merchantCount: updatedConsolidation?.merchantCount,
          })
            .then(async () => {
              if (!userActiveData?.serialNumber) {
                await updateSerialNumber(packageGlobal);
                await updatePackageColidationStatus(updatedPackageIds, {
                  packageStatus: "RECEIVED_AT_WAREHOUSE",
                  isConsolidatedPackage: true,
                });
                const updatedPackageDetails = await getDetailsById(
                  [
                    {
                      key: "__name__",
                      operator: "==",
                      value: packageActiveData?.id,
                    },
                  ],
                  "shelfConsolidatedPackages",
                );
                console.log(
                  updatedPackageDetails,
                  "updatedPackageDetailsupdatedPackageDetails",
                );

                dispatch(setSelectedRequest(updatedPackageDetails[0]));
                // await sendNotification(updatedPackageDetails[0]?.userId, "Package is ready for shipment", `Your Bundle ${updatedPackageDetails[0]?.consolidatedPackageName} is now ready for shipment. Please proceed to selecting your shipping option for shipping and delivery.`, {
                //   number: "",
                //   type: "BUNDLE-UP"
                // }, "Select Shipment")
                const userDetails = await getUserDetailsById(
                  updatedPackageDetails[0]?.userId,
                );
                await sendNotificationFunction({
                  eventType: "BUNDLE",
                  eventStatus: "CONSOLIDATION_APPROVED",
                  fcmToken: userDetails?.fcmToken,
                  userId: userDetails?.id,
                  mailId: userDetails?.emailId,
                  payload: {
                    bundleId: updatedPackageDetails?.id,
                    packageIds: updatedPackageDetails?.packageIds,
                    userName: userDetails?.name,
                  },
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });

          toast.success("Consolidated request prepared successfully");
          // Fetch updated data
          const updatedDoc = await getDoc(docRef);
          const updatedData = updatedDoc.data();
          console.log("Updated Data:", updatedData);
        } catch (err) {
          console.log(err);
          toast.error("Something went wrong");
        }
      }
    } else {
      if (!packageId) return;
      console.log(packageId, "dffcsdsdf");

      const newPackageStatus =
        packageActiveData?.packageStatus === "RE_PREPARE_PACKAGE"
          ? "RE_PREPARE_PACKAGE_COMPLETED"
          : "PREPARE_SHIPMENT_REQUEST_APPROVED";

      updateDoc(doc(db, "shelfPackages", packageId), {
        // packageShipmentStatus: "PREPARED",
        packageStatus: newPackageStatus,
        preparedShipmentDate: new Date(),
      })
        .then(async (res) => {
          dispatch(
            setSelectedPackage({
              ...packageActiveData,
              packageStatus:
                packageActiveData?.packageStatus === "RE_PREPARE_PACKAGE"
                  ? "RE_PREPARE_PACKAGE_COMPLETED"
                  : "PREPARE_SHIPMENT_REQUEST_APPROVED",
              preparedShipmentDate: new Date(),
            }),
          );
          sendNotification(
            packageActiveData?.userId,
            "Package is ready for shipment",
            `Your package ${packageActiveData?.id} is now ready for shipment. Please proceed to selecting your shipping option for shipping and delivery.`,
            {
              number: packageActiveData?.id,
              type: "PACKAGE",
            },
            "Ship now",
          )
            .then(() => {
              console.log("success");
            })
            .catch((error) => {
              console.log(error, "failed");
            });
          toast.success("Shipment prepared successfullyyyyyy");
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrongdfdsf");
        });
    }
  };

  const handleDownload = async (data1, data2, data3) => {
    try {
      let name = data1 ? data2 : "No Name";
      let sname = data3 ? data3 : "No SerialNumber";
      const element = slipRef.current;

      // Capture the element as a canvas
      const scale = 3; // Higher scale for better quality
      const canvas = await html2canvas(element, {
        scale,
        backgroundColor: "#fff", // Ensure background color
      });

      // Log the original canvas size
      const originalWidth = 945;
      const originalHeight = 591;
      console.log(
        `Original Width: ${originalWidth}, Original Height: ${originalHeight}`,
      );

      // Create a new canvas with the same size
      const scaledCanvas = document.createElement("canvas");
      scaledCanvas.width = originalWidth;
      scaledCanvas.height = originalHeight;
      const context = scaledCanvas.getContext("2d");

      // Draw the original canvas onto the new canvas
      context.drawImage(canvas, 0, 0, originalWidth, originalHeight);

      // Convert the scaled canvas to a data URL
      const dataURL = scaledCanvas.toDataURL("image/png");

      // Create a link element and set it to download the image
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = `${name}+${sname}.png`;

      // Append the link to the body to ensure it works across browsers
      document.body.appendChild(link);

      // Trigger the download by simulating a click
      link.click();

      // Remove the link after the download
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error generating image:", error);
    }
  };

  const updateShipStatus = async (shipmentId) => {
    const docRef = doc(db, "shipments", shipmentId);
    updateDoc(docRef, {
      isShipmentShipped: true,
    });
  };

  const shoppingCompleteHandler = async () => {
    console.log(packageItems, "packageItemss");

    // const itemsDetails = await getAllItems(packageActiveData?.packageItemIds);
    // itemsDetails?.map((item) => {
    //   if (!item?.postShopping?.trackingNumber) {
    //     toast.error(`add all tracking numbers`)
    //     return false;
    //   }
    // });
    updateShelfShoppingPackageDetails(packageActiveData?.id, {
      isShoppingRequestCompleted: true,
      completedAt: new Date(),
      status: "SHOPPING_COMPLETED",
    }).then(async (res) => {
      // sendNotification(packageActiveData?.userId, "Shopping Request Complete Notification", `Your shopping request ${packageActiveData?.id} has been completed. We'll notify you as soon as we receive your item(s).`, {
      //   number: packageActiveData?.id,
      //   type: "SHOPPING"
      // })
      const userDetails = await getUserDetailsById(packageActiveData?.userId);
      await sendNotificationFunction({
        eventType: "SHOPPING",
        eventStatus: "SHOPPING_REQUEST_COMPLETED",
        fcmToken: userDetails?.fcmToken,
        userId: userDetails?.id,
        mailId: userDetails?.emailId,
        payload: {
          shoppingId: packageActiveData?.id,
        },
      });
      toast.success("Shopping request completed successfully !");
    });
    const shelfPackage = await getShelfShoppingPackages([
      {
        key: "mySuiteId",
        operator: "==",
        value: userActiveData?.id,
      },
    ]);
    dispatch(setSelectedPackage(null));
    dispatch(setPackages(shelfPackage));
  };
  console.log(packageActiveData, "packageActiveDatanmj");

  return (
    <>
      {!activeDataName && (
        <Box sx={{ paddingTop: "16px", paddingRight: "20px" }}>
          <Box sx={{ marginLeft: "20px", mb: "16px" }}>
            <Typography variant="h5">
              Tracking: {packageActiveData?.trackingNumber}
            </Typography>
          </Box>
          <PackageStatus steps={steps} activeStep={activeStep} />
          <SerialNumber
            SerialNumber={packageActiveData?.serialNumber || "-"}
            packageTotalAmount={
              packageActiveData?.packageTotalAmount ||
              packageActiveData?.totalAmount
            }
            shipmentData={userActiveData}
            userClickHandler={userClickHandler}
            pageName={pageName}
            reloadDetails={reloadDetails}
          />
          <PackageDetails packageActiveData={packageActiveData} />
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              justifyContent: "center",
              borderBottom: "1px solid #E5E5E8",
              paddingBottom: "30px",
              flexWrap: "wrap",
            }}
          >
            {pageName !== "shippingComplete" && (
              <Button
                variant="contained"
                disabled={
                  !packageActiveData ||
                  (pageName === "consolidateRequest" &&
                    !packageActiveData?.dimensionH &&
                    !packageActiveData?.dimensionW &&
                    !packageActiveData?.dimensionL)
                }
                sx={{
                  backgroundColor: "white",
                  color: "#481AA3",
                  marginLeft: "10px",
                  border: "1px solid #E5E5E8",
                  borderRadius: "4px",
                  boxShadow: "none",
                  whiteSpace: "nowrap",
                  marginTop: "20px",
                  "&:hover": {
                    outline: "none",
                    color: "#481AA3",
                    backgroundColor: "white", // Remove border color on focus
                  },
                }}
                onClick={() => toggleDrawer(packageActiveData)}
              >
                <img src={edit} alt="star" style={{ marginRight: "10px" }} />
                Edit Package Details
              </Button>
            )}
            <EditPackageDrawer
              pageName={pageName}
              open={drawerOpen}
              onClose={toggleDrawer}
              collectionName={collection}
              shipmentCollectionName={shipmentCollection}
              shipmentData={userActiveData}
            />

            <Box sx={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
              <Slip
                ref={slipRef}
                name={
                  packageActiveData?.suiteNumber
                    ? packageActiveData?.name
                    : "No Name"
                }
                date={dateForSlip}
                suiteNumber={
                  packageActiveData?.suiteNumber
                    ? packageActiveData?.suiteNumber
                    : "No Suite"
                }
                packageId={
                  packageActiveData?.packageId && packageActiveData?.packageId
                }
                barcodeValue={
                  packageActiveData?.serialNumber
                    ? packageActiveData?.serialNumber
                    : barcodeValue
                }
              />
            </Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "white",
                color: "#481AA3",
                marginLeft: "10px",
                border: "1px solid #E5E5E8",
                boxShadow: "none",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#481AA3",
                  backgroundColor: "white", // Remove border color on focus
                },
              }}
              disabled={!packageActiveData?.serialNumber}
              onClick={() =>
                handleDownload(
                  packageActiveData?.suiteNumber,
                  packageActiveData?.name,
                  packageActiveData?.serialNumber,
                )
              }
            >
              <img src={slip} alt="slip" style={{ marginRight: "10px" }} />
              Receiving Slip
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                userActiveData?.labelUrl &&
                  window.open(userActiveData?.labelUrl, "_blank");
              }}
              disabled={
                pageName === "packages" ||
                pageName === "shippingRequest" ||
                pageName === "consolidateRequest" ||
                pageName === "shopping request" ||
                pageName === "expressRequest" ||
                pageName === "NoSuites" ||
                pageName === "Abandoned" ||
                !userActiveData?.labelUrl
              }
              sx={{
                backgroundColor: "white",
                color: "#481AA3",
                marginLeft: "10px",
                border: "1px solid #E5E5E8",
                boxShadow: "none",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#481AA3",
                  backgroundColor: "white", // Remove border color on focus
                },
              }}
            >
              <img src={slip} alt="slip" di style={{ marginRight: "10px" }} />
              Shipping Label
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                userActiveData?.customerDeclaration &&
                  window.open(userActiveData?.customerDeclaration, "_blank");
              }}
              disabled={
                pageName === "packages" ||
                pageName === "shippingRequest" ||
                pageName === "consolidateRequest" ||
                pageName === "shopping request" ||
                pageName === "expressRequest" ||
                pageName === "NoSuites" ||
                pageName === "Abandoned" ||
                !userActiveData?.customerDeclaration
              }
              sx={{
                backgroundColor: "white",
                color: "#481AA3",
                marginLeft: "10px",
                border: "1px solid #E5E5E8",
                boxShadow: "none",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#481AA3",
                  backgroundColor: "white", // Remove border color on focus
                },
              }}
            >
              <img src={slip} alt="slip" di style={{ marginRight: "10px" }} />
              Customer Declaration
            </Button>

            {pageName === "shopping request" && (
              <Button
                variant="contained"
                onClick={shoppingCompleteHandler}
                disabled={
                  !packageActiveData ||
                  packageActiveData?.isShoppingRequestCompleted ||
                  !packageItems?.every(
                    (item) => !!item?.postShopping?.orderNumber,
                  )
                }
                sx={{
                  backgroundColor: "white",
                  color: "#481AA3",
                  marginLeft: "10px",
                  border: "1px solid #E5E5E8",
                  boxShadow: "none",
                  borderRadius: "4px",
                  whiteSpace: "nowrap",
                  marginTop: "20px",
                  "&:hover": {
                    outline: "none",
                    color: "#481AA3",
                    backgroundColor: "white", // Remove border color on focus
                  },
                }}
              >
                <img src={slip} alt="slip" di style={{ marginRight: "10px" }} />
                Shopping Complete
              </Button>
            )}
            {(pageName === "shippingRequest" ||
              pageName === "expressRequest") && (
              <Button
                variant="contained"
                onClick={() =>
                  packageActiveData?.packagePhotos?.length > 0
                    ? handlePreparedShipment(packageActiveData?.id)
                    : toggleDrawer(packageActiveData)
                }
                disabled={
                  // !packageActiveData?.serialNumber ||
                  packageActiveData?.packageStatus !==
                    "PREPARE_SHIPMENT_REQUESTED" &&
                  packageActiveData?.packageStatus !== "RE_PREPARE_PACKAGE"
                }
                sx={{
                  backgroundColor: "white",
                  color: "#481AA3",
                  marginLeft: "10px",
                  border: "1px solid #E5E5E8",
                  boxShadow: "none",
                  borderRadius: "4px",
                  whiteSpace: "nowrap",
                  marginTop: "20px",
                  "&:hover": {
                    outline: "none",
                    color: "#481AA3",
                    backgroundColor: "white", // Remove border color on focus
                  },
                }}
              >
                {packageActiveData?.packageStatus ===
                "PREPARE_SHIPMENT_REQUESTED"
                  ? `Prepare Shipment`
                  : `Reprepare Package`}
              </Button>
            )}
            {pageName === "consolidateRequest" && (
              <Button
                variant="contained"
                onClick={() =>
                  packageActiveData?.dimensionW &&
                  packageActiveData?.dimensionL &&
                  packageActiveData?.dimensionH
                    ? handlePreparedShipment(packageActiveData?.id)
                    : toggleConsolidateDrawer(packageActiveData)
                }
                disabled={
                  ![
                    "CONSOLIDATION_REQUESTED",
                    "CONSOLIDATION_PREPARE_SHIPMENT_REQUESTED",
                    "CONSOLIDATION_RE_PREPARE_PACKAGE",
                  ].includes(userActiveData?.status) ||
                  (userActiveData?.status === "CONSOLIDATION_REQUESTED" &&
                    userActiveData?.packageIds?.length !==
                      selectedPackages?.length)
                }
                sx={{
                  backgroundColor: "white",
                  color: "#481AA3",
                  marginLeft: "10px",
                  border: "1px solid #E5E5E8",
                  boxShadow: "none",
                  borderRadius: "4px",
                  whiteSpace: "nowrap",
                  marginTop: "20px",
                  "&:hover": {
                    outline: "none",
                    color: "#481AA3",
                    backgroundColor: "white", // Remove border color on focus
                  },
                }}
              >
                {["CONSOLIDATION_REQUESTED"].includes(userActiveData?.status)
                  ? `Prepare Consolidation`
                  : [
                        "CONSOLIDATION_APPROVED",
                        "CONSOLIDATION_PREPARE_SHIPMENT_REQUESTED",
                        "CONSOLIDATION_PREPARE_SHIPMENT_REQUEST_APPROVED",
                      ].includes(userActiveData?.status)
                    ? `Prepare Shipment`
                    : `Reprepare Consolidation`}{" "}
                {pageName === "consolidateRequest" &&
                  userActiveData?.status === "CONSOLIDATION_REQUESTED" && (
                    <span className="text-lg ps-2">
                      {selectedPackages?.length || 0}
                    </span>
                  )}
              </Button>
            )}
            <Button
              variant="contained"
              onClick={() => {
                updateShipStatus(userActiveData?.id);
              }}
              disabled={
                !userActiveData?.packing_slip ||
                !userActiveData?.easyshipShipmentId ||
                !userActiveData?.isShipmentShipped
              }
              sx={{
                backgroundColor: "white",
                color: "#481AA3",
                marginLeft: "10px",
                border: "1px solid #E5E5E8",
                boxShadow: "none",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#481AA3",
                  backgroundColor: "white", // Remove border color on focus
                },
              }}
            >
              <img src={slip} alt="slip" di style={{ marginRight: "10px" }} />
              {userActiveData?.isShipmentShipped ? "Ship" : "Shipped"}
            </Button>
            <EditConsolidatedPackageDrawer
              pageName={pageName}
              editPackage={editPackageData}
              open={consolidatePackageDrawerOpen}
              onClose={toggleConsolidateDrawer}
              collectionName={collection}
              shipmentCollectionName={shipmentCollection}
              shipmentData={userActiveData}
            />
          </Box>
          {packageActiveData?.serialNumber && (
            <SelectionTag packageActiveData={packageActiveData} />
          )}
          <Box
            sx={{
              borderBottom: "1px solid #E5E5E8",
              paddingBottom: "30px",
            }}
          >
            <Box sx={{ marginLeft: "20px", marginTop: "20px" }}>
              <h1
                style={{
                  textAlign: "left",
                  fontSize: " 26px",
                  fontWeight: "bold",
                }}
              >
                Package images
              </h1>
            </Box>
            <SimpleBar
              forceVisible="x"
              autoHide={true}
              style={{
                overflowX: "auto",
              }}
              className="custom-scrollbar"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "20px",
                  marginTop: "20px",
                }}
              >
                {(collection === "shelfShoppingPackages"
                  ? packageActiveData?.shoppingImages
                  : packageActiveData?.packageImages
                )
                  ?.filter((url) => url !== "")
                  ?.map((url, index) => (
                    <Box sx={{ marginRight: "20px" }}>
                      {url ? (
                        <img
                          src={url}
                          alt="package"
                          key={index}
                          style={{
                            height: "120px",
                            width: "120px",
                            minWidth: "120px",
                            minHeight: "120px",
                            maxWidth: "120px",
                            maxHeight: "120px",
                          }}
                        />
                      ) : (
                        "-"
                      )}
                    </Box>
                  ))}
              </Box>
            </SimpleBar>
          </Box>
          <Box sx={{ paddingBottom: "30px" }}>
            <Box sx={{ marginLeft: "20px", marginTop: "20px" }}>
              <h1
                style={{
                  textAlign: "left",
                  fontSize: " 26px",
                  fontWeight: "bold",
                }}
              >
                Item List
              </h1>
            </Box>
            {rows && (
              <CustomTable
                rows={rows}
                headCells={headCells}
                setActiveDataName={setActiveDataName}
                setActiveDataImage={setActiveDataImage}
                packageActiveData={packageActiveData}
                userActiveData={userActiveData}
                packageCollection={collection}
                shipmentCollection={shipmentCollection}
              />
            )}
          </Box>
        </Box>
      )}
      {activeDataName && (
        <AccordionViaTableRowName
          handleBack={handleBackButton}
          packageClickHandler={() => {
            packageClickHandler();
            setActiveDataName(null);
          }}
          id={activeDataName}
          packageActiveData={packageActiveData}
          userActiveData={userActiveData}
          packageItems={packageItems}
          pageName={pageName}
          packageCollection={collection}
          shipmentCollection={shipmentCollection}
        />
      )}
    </>
  );
}

export default PackageTraking;
